import { useState, useEffect } from 'react';
import {
  getHeadersUnwrapped,
  searchEmails,
  searchEmailsAdmin,
  useUserContext,
  EmailOption,
} from '../common';
import { compose as lcompose } from 'lodash/fp';

export const useEmailSearch = ({
  forRegistrantsNCoordinators,
}: {
  forRegistrantsNCoordinators: boolean;
}) => {
  const { user } = useUserContext();

  const [emailInput, setEmailInput] = useState('');
  const [options, setOptions] = useState<EmailOption[]>([]);

  useEffect(() => {
    lcompose(
      forRegistrantsNCoordinators ? searchEmails : searchEmailsAdmin,
      getHeadersUnwrapped
    )(user)(emailInput).then(setOptions);
  }, [forRegistrantsNCoordinators, emailInput, user]);

  return { emails: options, emailInput, setEmailInput };
};
